
export function createSubmitData(requestId, formData) {

    let submitData = {
        items: [],
        requestId: parseInt(requestId)
    }

    // create items list
    formData.items.forEach(item => {
        submitData.items.push({
            equipment: parseInt(item.id),
            requestedQuantity: parseInt(item.requestedQuantity)
        })
    })

    return submitData
}
